import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import MuiChip from "@mui/material/Chip";
import classNames from "classnames";
import useStyles from "./Chip.styles";
const Chip = forwardRef(({ color, backgroundColor, className, ...muiProps }, ref) => {
    const { classes } = useStyles({ color, backgroundColor });
    return (_jsx(MuiChip, { ref: ref, className: classNames(classes.root, className), size: "small", ...muiProps }));
});
export default Chip;
